'use strict';

// Publisher identity belongs to the site, independently of stored page copy.
module.exports = Object.freeze({ logoUrl: 'https://cdn.gab.ai/brand-assets/gab-ai-mark-black.svg' });
